class SubmitOnChangeService {

    constructor() {
        this.forms = [];
    }
}

export default SubmitOnChangeService;